enum MovieGenreListActionType {
  FETCH_MOVIE_GENRE_LIST_REQUEST = 'FETCH_MOVIE_GENRE_LIST_REQUEST',
  FETCH_MOVIE_GENRE_LIST_REQUEST_SUCCESS = 'FETCH_MOVIE_GENRE_LIST_REQUEST_SUCCESS',
  FETCH_MOVIE_GENRE_LIST_REQUEST_ERROR = 'FETCH_MOVIE_GENRE_LIST_REQUEST_ERROR',
}

export default MovieGenreListActionType
